import masonry from 'masonry-layout';
import themeUtils from '../themeUtils';

export default class MasonryGrid {
  constructor(options) {
    this.$el = options.$el;

    const defaultSettings = {
      itemSelector: '[data-masonry-item]',
      columnWidth: '[data-masonry-sizer]',
      gutter: 0,
      percentPosition: false
    };

    this.settings = themeUtils.extend(defaultSettings, options.settings);

    this.$masonry = this.$el.masonry(this.settings);
    this.$masonry.masonry('layout');
    this.$el.on("rimg:load", () => this.$masonry.masonry('layout'));
  }

  unload() {
    this.$masonry.masonry('destroy');
  }
}
